import { useEffect, useState } from "react";
import PaginationComponent from "../../components/UIElements/Pagination/Pagination";
import { getAllEmailLogs } from "../../services/EmailLogsService";
import { SentEmailLogDto } from "../../interfaces/IEmailLogs";
import { PulseLoader } from "react-spinners";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import { AlertsTimeFilter } from "../../mock/MockData";
import "./Alerts.css";
import EmailLogAccordionRow from "../../components/UIElements/EmailLogAccordion/EmailLogAccordionRow";

const Alerts = () => {
  const MIN_ITEMS = sessionStorage.getItem("itemsPerPage")
    ? parseInt(sessionStorage.getItem("itemsPerPage")!)
    : 10;

  const [emailLogs, setEmailLogs] = useState<SentEmailLogDto[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filter, setFilter] =  useState<string>("Today");

  const fetchEmailLogs = async (pageNumber = 1) => {
    try {
      setIsLoading(true);
      const appliedFilter = filter === "All" ? undefined : filter;
      const response = await getAllEmailLogs(MIN_ITEMS, pageNumber, null, appliedFilter);
      
      if (response.emailLogs.length === 0) {
        toast.info("No email logs available.");
      }
      setEmailLogs(response.emailLogs);
      setTotalPages(response.totalPages || 1);
    } catch (error) {
      console.error("Error fetching email logs:", error);
      toast.error("Failed to fetch email logs");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
      fetchEmailLogs(currentPage);
  }, [filter, currentPage]);

  return (
    <>
      <div className="page-title">
        <p>Alerts</p>
        <p className="page-subtitle">View all sent alerts.</p>
      </div>
      <div className="d-flex">
        <select className="loadprofile-select-table" onChange={(event) => setFilter(event.target.value)} value={filter}>
          {AlertsTimeFilter.map((item) => (
            <option value={item} key={item}>{item}</option>
          ))}
        </select>
      </div>
      <div className="container-fluid mt-2">
        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col" className="th">Timestamp</th>
              <th scope="col" className="th">Subject</th>
              <th scope="col" className="th">Trigger</th>
              <th scope="col" className="th">Details</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={4} className="text-center align-middle">
                  <div className="d-flex justify-content-center align-items-center" style={{ height: "100px" }}>
                    <PulseLoader />
                  </div>
                </td>
              </tr>
            ) : emailLogs.length > 0 ? (
              emailLogs.map((log, index) => <EmailLogAccordionRow key={index} log={log} />)
            ) : (
              <tr>
                <td colSpan={4} className="text-center">No email logs available</td>
              </tr>
            )}
          </tbody>
        </table>
        <PaginationComponent currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
        <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
      </div>
    </>
  );
};

export default Alerts;
